import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { AllPermissionDropdown } from "../../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingleInstrument,
  InstrumentMaintanceUpdate,
  GetAllInstrument,
  InstrumentUpdate,
} from "../../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";

import { formatDateForInput } from "../../../../../../../../utils/common";
import { useFieldArray } from "react-hook-form";
import { FixIDS } from "../../../../../../../../utils/fixIDS";

function Instrument_Check_Edit_Offcanvas({ show, handleClose, id,fetchCustomers }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const allPermissionDropdown = useSelector(
    (state) => state.common.all_permission_dropdown,
  );
  const all_instruments = useSelector(
    (state) => state.common.all_instrument_management,
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "observations",
  });

  useEffect(() => {
    dispatch(AllPermissionDropdown());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingleInstrument(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.message;

        const selectedMaintenance =
          data.Instrument_Check_Points?.map((item) => ({
            value: item.maintenance_check_point_id,
            label: item?.Maintenance_Check_Points_Seeder?.name,
          })) || [];

        reset({
          instrument_id:
            all_instruments?.find(
              (opt) => opt.value === data.instrument_management_id,
            ) || null,

          user_id: data.user_id
            ? {
                value: data.user_id,
                label: data?.User?.name || "",
              }
            : null,

          from_date: data.from_date || "",
          to_date: data.to_date || "",
          next_date: data.next_date || "",
          remark: data.remark || "",

          //MAIN
          maintenance_check_point_id: selectedMaintenance,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (show && id) {
      GetData(id);
    }
  }, [show, id]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = {
        instrument_id: data.instrument_id?.value,
        user_id: data.user_id?.value,
        from_date: data.from_date,
        next_date: data.next_date,
        to_date: data.to_date,
        remark: data.remark,

        maintenance_check_point_id: data.maintenance_check_point_id?.map(
          (item) => item.value,
        ),
      };

      const res = await dispatch(InstrumentUpdate({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAllInstrument());

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Instrument Check
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Instrument</Form.Label>
                  {/* Instrument */}
                  <Controller
                    name="instrument_id"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={all_instruments}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                  {errors.instrument_id && (
                    <span className="text-danger">
                      {errors.instrument_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Checked By</Form.Label>
                  {/* User */}
                  <Controller
                    name="user_id"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={allPermissionDropdown}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                  {errors.user_id && (
                    <span className="text-danger">
                      {errors.user_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>From Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("from_date", {
                      // required: "From Date is required",
                    })}
                  />
                  {errors.from_date && (
                    <span className="text-danger">
                      {errors.from_date.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>To Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("to_date", {
                      // required: "To Date is required",
                    })}
                  />
                  {errors.to_date && (
                    <span className="text-danger">
                      {errors.to_date.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Next Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("next_date", {
                      required: "From Date is required",
                    })}
                  />
                  {errors.next_date && (
                    <span className="text-danger">
                      {errors.next_date.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "Remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>

            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Instrument_Check_Edit_Offcanvas;
